var map = {
	"./1.png": 2951,
	"./2.png": 2952,
	"./3.png": 2953,
	"./4.png": 2954
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 379;



//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/smilies .\.png*
// module id = 379
// module chunks = 0